import React, { useEffect, useState } from 'react';

import PrivateRoute from '../../../components/private-route';
import Footer from './footer';
import Header from './header';
const Layout2 = ({ component: Component, ...rest }: any) => {
    const [, setWindowSize] = useState({ width: undefined })


    useEffect(() => {

        function handleResize() {
            setWindowSize({
                width: window.innerWidth,
            });
        }
        setWindowSize({ width: window.innerWidth })

        window.addEventListener("resize", handleResize);

        handleResize();

        return () => window.removeEventListener("resize", handleResize);
    }, [])

    return (
        <PrivateRoute
            {...rest}
            render={props => (
                <>

                    <Header />
                    <Component {...props} />
                    <Footer />


                </>
            )}
        />
    );
};

export default Layout2;
